<template>
    <div class="family-layout hero is-large">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-12">
                    <div class="box">
                        <div
                            class="title is-flex is-align-content-center is-align-items-center is-justify-content-center"
                        >
                            <div class="mr-2">
                                <b-icon pack="mdi" icon="check-circle-outline" size="is-large" type="is-primary">
                                </b-icon>
                            </div>
                            <div>AI REUSIT!</div>
                        </div>
                        <div class="subtitle is-size-6">
                            <p>
                                Formularul tau a ajuns deja in baza noastra de date si il vom depune cat mai curand la
                                ANAF.
                            </p>
                            <!-- <p>
                                Daca ai completat adresa de email, iti vom trimite si tie o copie a formularului, pentru
                                arhiva personala.
                                <span v-if="hasPDFData"
                                    >In caz contrar, il poti descarca de
                                    <strong><a @click="downloadPDF">aici</a></strong
                                    >.</span
                                >
                            </p> -->
                            <p>
                                Pentru intrebari sau nelamuriri, te rugam sa ne contactezi la adresa de email
                                <strong
                                    ><a href="mailto:formulare@minticreative.org"
                                        >formulare@minticreative.org</a
                                    ></strong
                                >
                                sau la <strong><a href="tel:0745609094">0745609094</a></strong
                                >.
                            </p>
                            <p>
                                Completarea acestui formular se va transforma in ore de terapie pentru copiii inscrisi
                                in Asociatia Minti Creative.
                            </p>
                            <p>Iti multumim mult pentru sprijinul acordat!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createBlob } from '@/utils/functions';

export default {
    name: 'RegistrationSuccess',
    computed: {
        hasPDFData() {
            return this.$route.params.pdfData != null;
        },
    },
    methods: {
        downloadPDF() {
            if (this.$route.params.pdfData == null) return false;
            const blobUrl = createBlob('application/pdf', this.$route.params.pdfData);
            const dlnk = document.createElement('a');
            dlnk.href = blobUrl;
            dlnk.setAttribute('target', '_blank');
            dlnk.download = 'formular.pdf';
            document.body.appendChild(dlnk);
            dlnk.click();
            dlnk.remove();
        },
    },
};
</script>
<style scoped>
.subtitle {
    line-height: 1.5;
}
</style>
